/* eslint-disable no-useless-escape */
import {decimalPrettifier} from './decimalPrettifier'
import {safeUnreachableCase} from './unreachableCase'

export const dollarsToCents = (dollars: number): number => Math.round(dollars * 100)

/**
 * Remove all characters other than digits, negative signs, and decimal points from a string
 * @param str String to clean
 * @returns {String}
 */
export const cleanDollarString = (str: string): string => {
  return str.replace(/[^\d\.\-]/g, '')
}

/**
 * Remove all characters other than digits, negative signs, and decimal points from a string
 * and returns string as a number
 * @param str String to clean
 * @returns {Number}
 */
export const dollarStringToFloat = (str: string): number => {
  return parseFloat(cleanDollarString(str))
}

export const dollarStringToCents = (str: string): number => {
  return dollarsToCents(dollarStringToFloat(str))
}

/** Returns a pretty dollar string from the given cents value. E.g. `1042.99` -> `$1,042.99` */
export const dollarsPrettifier = (
  dollars: number | undefined,
  withDollarSign: boolean = true,
  centsDigits: 2 | 0 | 'twoWhenNecessary' = 2
): string => {
  if (dollars === undefined || isNaN(dollars)) {
    return ''
  }

  const centsDigitsAsNumber = ((): 0 | 2 => {
    switch (centsDigits) {
      case 0:
      case 2:
        return centsDigits
      case 'twoWhenNecessary':
        // are there any cents? if so, 2 digits, otherwise 0
        return Math.abs(dollarsToCents(dollars)) % 100 === 0 ? 0 : 2
      default:
        return safeUnreachableCase(centsDigits, 2)
    }
  })()

  const pretty = decimalPrettifier(dollars, centsDigitsAsNumber, true)
  return withDollarSign
    ? pretty.replace(/^([^\d])*/, '$1$') // so that `-5.32` -> `-$5.32`
    : pretty
}
